export default __webpack_public_path__ + "static/media/longtone.8dd1e94e.png";